import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import { AuthProvider } from './components/AuthProvider'
import { ActiveClientProvider } from './components/ActiveClientProvider'
import { router } from './routes'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ActiveClientProvider>
          <RouterProvider router={router} />
        </ActiveClientProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
